import { render, staticRenderFns } from "./CompletedTestTable.vue?vue&type=template&id=93e5d83c&"
import script from "./CompletedTestTable.vue?vue&type=script&lang=js&"
export * from "./CompletedTestTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports